// extracted by mini-css-extract-plugin
export default {"addClassContainer":"AddClasses_addClassContainer__xHHPI","closeButton":"AddClasses_closeButton__ZjlI9","fadeIn":"AddClasses_fadeIn__1LzvY","fadeOut":"AddClasses_fadeOut__6QQ+B"};